import { Accordion, AccordionDetails, AccordionSummary, Box, Button, CircularProgress, IconButton, Typography, useTheme } from '@mui/material';
import Header from '../../../../components/Header';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';
import { tokens } from '../../../../theme';
import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { UserContext } from '../../../../context/UserContext';
import {
    Chart as ChartJS,
    LinearScale,
    PointElement,
    Tooltip,
    Legend,
} from 'chart.js';
import BrandProdcutDialog from '../../../../components/BrandProdcutDialog';
import InfiniteScroll from 'react-infinite-scroll-component';
import BrandProductBox from '../../../../components/BrandProductBox';
import AlertDialogSlide from '../../../../components/AlertDialogSlide';

ChartJS.register(LinearScale, PointElement, Tooltip, Legend);

function IndependentCouponDetails() {
    const navigate = useNavigate();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { token } = useContext(UserContext);
    const couponId = window.location.pathname.split("/")[window.location.pathname.split("/").length - 1];

    const [coupon, setCoupon] = useState(null);
    const [brandProducts, setBrandProducts] = useState([]);
    const [productDialogOpen, setProductDialogOpen] = useState(false);
    const [targetProduct, setTargetProduct] = useState(null);
    const [hasMoreProduct, setHasMoreProduct] = useState(true);
    const [alertDialogOpen, setAlertDialogOpen] = useState(false);

    useEffect(() => {
        fetchCouponData();
        getBrandProducts(0);
    }, []);

    useEffect(() => {
        if (targetProduct) {
            setProductDialogOpen(true);
        }
    }, [targetProduct])

    const fetchCouponData = () => {
        axios.get(`${process.env.REACT_APP_API_URL}api/alcago/brand/getIndependentCoupon?token=${token}&independentCouponId=${couponId}`)
            .catch((err) => {
                console.log("err: " + err);
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 200 && response.data.independentCoupon) {
                    setCoupon(response.data.independentCoupon);
                }
            });
    }

    const getBrandProducts = (startIndex) => {
        axios.get(`${process.env.REACT_APP_API_URL}api/alcago/brandProduct/getBrandProducts?token=${token}&independentCouponId=${couponId}&startIndex=${startIndex}`)
            .catch((err) => {
                console.log("err: " + err);
                setHasMoreProduct(false);
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 200) {
                    if (response.data.brandProducts) {
                        setBrandProducts(response.data.brandProducts);
                        if (response.data.brandProducts.length < 20) {
                            setHasMoreProduct(false);
                        }
                    }
                }
            });
    }

    const handleBrandProductSave = async (values) => {
        if (values.image1 || values.image2 || values.image3) {
            await axios.post(`${process.env.REACT_APP_API_URL}api/alcago/brandProduct/uploadBrandProductImages?token=${token}`, {
                ...(values.image1 ? { image1: values.image1 } : {}),
                ...(values.image2 ? { image2: values.image2 } : {}),
                ...(values.image3 ? { image3: values.image3 } : {})
            }, {
                headers: {
                    "content-type": "multipart/form-data"
                }
            })
                .catch((err) => {
                    console.log("err: " + err);
                })
                .then((response) => {
                    if (response && response.data.success === true && response.data.status === 201) {
                        if (values.image1) {
                            delete values.image1;
                            delete values.image_path_1;
                            values.image_path_1 = response.data.imagePath1;
                        }
                        if (values.image2) {
                            delete values.image2;
                            delete values.image_path_2;
                            values.image_path_2 = response.data.imagePath2;
                        }
                        if (values.image3) {
                            delete values.image3;
                            delete values.image_path_3;
                            values.image_path_3 = response.data.imagePath3;
                        }
                    }
                });
        }

        delete values.image1;
        delete values.image2;
        delete values.image3;
        if (targetProduct) {
            //update

            const productIndex = brandProducts.findIndex((bp) => bp.id === targetProduct.id);

            if (productIndex !== -1) {
                const updatedProducts = [...brandProducts];
                updatedProducts[productIndex] = { ...updatedProducts[productIndex], ...values };
                setBrandProducts(updatedProducts);
            }
            delete values.image_link_1;
            delete values.image_link_2;
            delete values.image_link_3;
            axios.patch(`${process.env.REACT_APP_API_URL}api/alcago/brandProduct/updateBrandProduct?brandProductId=${targetProduct.id}&token=${token}`, { brandProduct: values })
                .catch((err) => {
                    console.log("err: " + err);
                })
                .then((response) => {
                    if (response && response.data.success === true && response.data.status === 201) {
                        setProductDialogOpen(false);
                        setTargetProduct(null);
                    }
                });
        } else {
            //create
            axios.post(`${process.env.REACT_APP_API_URL}api/alcago/brandProduct/?token=${token}`, { brandProduct: values })
                .catch((err) => {
                    console.log("err: " + err);
                })
                .then((response) => {
                    if (response && response.data.success === true && response.data.status === 201) {
                        setProductDialogOpen(false);
                    }
                });
        }
    };

    const handleEditProduct = (product) => {
        setTargetProduct(product);
    };

    const handleDeleteProduct = (product) => {
        axios.delete(`${process.env.REACT_APP_API_URL}api/alcago/brandProduct/deleteBrandProduct?brandProductId=${product.id}&token=${token}`)
            .catch((err) => {
                console.log("err: " + err);
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 201) {
                    setProductDialogOpen(false);
                }
            });
    };

    return (
        <Box mt="20px">
            {!coupon &&
                <Box height="100%" width="100%" display="flex" justifyContent="center" alignItems="center">
                    <CircularProgress color="inherit" />
                </Box>
            }
            {coupon &&
                <Box>
                    <AlertDialogSlide
                        open={alertDialogOpen} handleClose={() => setAlertDialogOpen(false)}
                        clickPositiveAnswer={handleDeleteProduct} clickNegativeAnswer={() => setAlertDialogOpen(false)}
                        positiveAnswer={"Sil"} negativeAnswer={"İptal"}
                        title={"Bu ürünü silmek istediğinize emin misiniz?"}
                        description={"Bu ürün ile ilişkili tüm veriler silinecektir."}
                    />
                    <BrandProdcutDialog
                        open={productDialogOpen}
                        handleClose={() => setProductDialogOpen(false)}
                        handleSubmit={handleBrandProductSave}
                        brandProduct={targetProduct}
                        adType={"independentCoupon"}
                        brandId={coupon.brand_id}
                        adId={couponId}
                    />
                    <Box display="flex">
                        <Box display="flex">
                            <IconButton style={{ width: "40px", height: "40px", marginRight: "5px" }}
                                onClick={() => {
                                    navigate(-1);
                                }}>
                                <ArrowBackIosNewOutlinedIcon />
                            </IconButton>
                            <Box display="flex" mr="5px">
                                <img
                                    alt="independent-coupon"
                                    src={coupon.thumbnail_image_link}
                                    width="40px"
                                    height="40px"
                                    style={{ cursor: "pointer", borderRadius: "50%" }} />
                            </Box>
                            <Box display="flex" gap={"30px"} ml="10px">
                                <Header title={coupon.brand_name} subtitle={coupon.coupon_title} />

                                <Button
                                    variant='contained'
                                    color='success'
                                    sx={{ margin: "10px 0 auto 0" }}
                                    onClick={() => {
                                        setProductDialogOpen(true);
                                    }}
                                >
                                    Ürün Ekle
                                </Button>

                            </Box>
                        </Box>

                    </Box>
                    <Box mx="30px" pt="20px" pb="20px" sx={{ background: colors.primary[400], borderRadius: "20px" }}>
                        <Typography display="inline-block" border={"1px solid " + colors.primary[100]} borderRadius="10px" p="10px" variant='h6' minWidth="150px" maxWidth="250px" ml="20px" mb="20px"><b>Yayınlanma Tarihi</b> <hr />{new Date(coupon.created_date).toLocaleTimeString("tr-TR", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</Typography>
                        <Typography display="inline-block" border={"1px solid " + colors.primary[100]} borderRadius="10px" p="10px" variant='h6' minWidth="100px" maxWidth="250px" ml="20px" mb="20px"><b>Kod</b> <hr />{coupon.coupon_code || "-"}</Typography>
                        <Typography display="inline-block" border={"1px solid " + colors.primary[100]} borderRadius="10px" p="10px" variant='h6' minWidth="100px" maxWidth="250px" ml="20px" mb="20px"><b>Kod Görüntülenme Sayısı</b> <hr />{coupon.code_view_count}</Typography>
                        <Typography display="inline-block" border={"1px solid " + colors.primary[100]} borderRadius="10px" p="10px" variant='h6' minWidth="100px" maxWidth="250px" ml="20px" mb="20px"><b>Link</b> <hr />{coupon.link || "-"}</Typography>
                        <Typography display="inline-block" border={"1px solid " + colors.primary[100]} borderRadius="10px" p="10px" variant='h6' minWidth="100px" maxWidth="250px" ml="20px" mb="20px"><b>Link Tıklanma Sayısı</b> <hr />{coupon.website_open_count}</Typography>
                        <Typography mt="20px" mx="20px"><b>Açıklama</b></Typography>
                        <hr style={{ marginLeft: "15px", marginRight: "15px" }} />
                        {<Typography mt="20px" mx="20px">{coupon.coupon_description}</Typography>}
                    </Box>

                    <Box m="30px 20px 0 20px" pb="30px">


                        <Accordion disabled={brandProducts.length < 1}>
                            <AccordionSummary id='coupon-accordion' expandIcon={<ExpandMoreIcon />}>
                                <Typography variant='h4'>Ürünler</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box m="10px 0 0 0" maxHeight="500px" overflow="auto">
                                    <InfiniteScroll
                                        dataLength={brandProducts.length}
                                        next={() => getBrandProducts(brandProducts.length)}
                                        hasMore={hasMoreProduct}
                                        loader={<h4>Yükleniyor...</h4>}
                                        endMessage={
                                            <p style={{ textAlign: 'center' }}>
                                                <b>Tüm ürünleri görüntülüyorsunuz.</b>
                                            </p>
                                        }
                                    >
                                        {brandProducts.map((product) => <BrandProductBox
                                            key={product.id}
                                            brandProduct={product}
                                            onEditClick={handleEditProduct}
                                            onDeleteClick={() => setAlertDialogOpen(true)}
                                        />)}
                                    </InfiniteScroll>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    </Box>
                </Box>
            }
        </Box>
    )
}

export default IndependentCouponDetails;